import { render, staticRenderFns } from "./modalCapNhatCapDonVi.vue?vue&type=template&id=faa37bb0&"
import script from "./modalCapNhatCapDonVi.vue?vue&type=script&lang=js&"
export * from "./modalCapNhatCapDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports